export default __webpack_public_path__ + "static/media/hero.b44fe61b.png";